import React from 'react';
import { Modal, Button, Table, Tag, Spin, Icon, Tooltip } from 'antd';
import { openNotification } from '../../util/notificaciones';
import Pedidos from '../../services/Pedidos';
import moment from 'moment'
import 'moment/locale/es';
moment.locale('es')
/**
 * Clase para ver el proceso al planear un pedido
 */
export default class DetallePedidosRealizados extends React.Component {
    state = {
        mostrarModalConfirm: false,
        rowDelete: null,
        articulosPedido: [],
        articulosPedidoOriginal: [],
        cargando: false,
        bloquearBtn: false,
        objArticuloCambio: null,
        mostrarModalCambio: false,
        cargandoCambio: false,
        proveedoresAdSitio: [],
        infoTablaCambio: [],
        selectedRowKeys: [],
        selectedRows: [],
        disableBtnCambio: true,
        mostrarConfirmacioneliminar: false,
        articuloCambioSelected: null,
        disableBtnContinuar: false,
        pedido_selected: null,
        bloquearAtras: false,
        objCancelarArticulo: null,
        pedidoModificado: null,
        paginaSiguiente: 1,
        paginacion: {},
        renderItems: []
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if ((this.props.pedido_selected !== prevProps.pedido_selected)) {
            if (this.props.tipo_modal === "Detalle") {
                if (this.props.pedido_selected !== null) {

                    state.articulosPedido = []
                    state.articulosPedidoOriginal = []
                    state.cargando = true;
                    this.setState(state, () => {
                        Pedidos.CargarArticulosPedidoPag(
                            this.props.pedido_selected.id,
                            undefined, // Esto corresponde al parámetro 'page'. Lo dejamos como 'undefined' para no enviarlo.
                            false,     // Esto corresponde al parámetro 'recibir'. Lo dejamos como 'false' (su valor por defecto).
                            0          // ¡Aquí es donde pasas el '0' para 'pageSize'!
                        ).then(response => {
                            state.cargando = false;
                            response.data.forEach((item) => {
                                if(item.cantidad_solicitada === 0)
                                {
                                    item.status = 'Cancelado';
                                }

                                item.status = item.status === null ? 'Creado' : item.status;
                            });

                            // Aquí ordenamos la respuesta simulada por código de proveedor y luego por delivery
                            const articulosOrdenados = response.data.sort((a, b) => {
                                if (a.codigo_proveedor === b.codigo_proveedor) {
                                    return a.delivery - b.delivery; // Si son del mismo proveedor, ordenamos por delivery
                                }
                                return a.codigo_proveedor.localeCompare(b.codigo_proveedor); // Si no, ordenamos por código de proveedor
                            });


                            // Usar handleHeaderArticles para procesar los artículos y agregar los headers
                            const renderItems = this.handleHeaderArticles(articulosOrdenados);
                            state.paginacion = {
                                current: state.paginaSiguiente,
                                total: renderItems.count,
                                onChange: this.handlePaginaChange,
                                pageSize: 10,
                                showTitle: false
                            }

                            // Actualizamos el estado con los productos procesados
                            state.articulosPedido = renderItems;
                            state.articulosPedidoOriginal = renderItems;
                            state.cargando = false;
                            this.setState(state);  



                        }).catch(err => {
                            this.setState({ cargando: false })
                            openNotification("No se han podido cargar los artículos del pedido.", "Error al cargar artículos", false)
                        })
                
                    });
                }
            }
        }
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de planeación de un pedido.
     */
    handleCancel = () => {
        let state = { ...this.state }
        state.paginaSiguiente = 1;
        this.setState(state)
        this.props.esconderModal(state.pedidoModificado);
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de confirmación para eliminar
     */
    cancelModalConfirm = () => {
        this.setState({ mostrarModalConfirm: false, rowDelete: null})
    }

    /**
     * Función que se manda a llamar cuando se abre el modal
     * de confirmación para eliminar
     */
    showModalConfirm = (record) => {
        this.setState({ mostrarModalConfirm: true, rowDelete: record })
    }

    /**
     * Función que se manda a llamar cuando elimina un
     * artículo del pedido
     */
    eliminarArticulo = () => {
        let state = { ...this.state }
        state.bloquearBtn = true;
        state.cargando = true;
        state.mostrarConfirmacioneliminar = false;

        this.setState(state, () => {
            Pedidos.CancelarArticuloSAP(state.objCancelarArticulo.id).then(response => {
                this.props.esconderModal(state.pedidoModificado)
                this.setState({ bloquearBtn: false, mostrarConfirmacioneliminar: false, cargando: false })
                openNotification("Se eliminó satisfactoriamente", "Eliminar artículo", true)
            }).catch(err => {
                this.setState({ bloquearBtn: false, mostrarConfirmacioneliminar: false, cargando: false })
                openNotification("No se ha podido eliminar el artículo del pedido.", "Error al eliminar artículo", false)
            });
        })
    }

    /**
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
        handlePaginaChange = (paginaSiguiente) => {
            let state = { ...this.state };
            state.cargando = true;
            state.paginaSiguiente = paginaSiguiente;

            this.setState(state, () => {
                Pedidos.CargarArticulosPedidoPag(this.props.pedido_selected.id, paginaSiguiente)
                    .then(response => {


                        // Procesamos los artículos (agregando los headers)
                        const articulosProcesados = this.handleHeaderArticles(response.data);

                        // Primero, configuramos la paginación
                        state.paginacion = {
                            current: state.paginaSiguiente,
                            total: articulosProcesados.count
                        };

                        // Actualizamos el estado con los artículos procesados
                        state.articulosPedido = articulosProcesados;
                        state.articulosPedidoOriginal = articulosProcesados;

                        state.cargando = false;
                        this.setState(state);
                    })
                    .catch(err => {
                        this.setState({ cargando: false });
                        openNotification("No se han podido cargar los artículos del pedido.", "Error", false);
                    });
            });
        };


    handleHeaderArticles = (articulos) => {

 
        articulos.sort((a, b) => {
            // Asegurarse de que los códigos de proveedor son strings para comparar
            const proveedorA = String(a.codigo_proveedor);
            const proveedorB = String(b.codigo_proveedor);

            // Comparación primaria: por código de proveedor
            if (proveedorA < proveedorB) {
                return -1; // a va antes que b
            }
            if (proveedorA > proveedorB) {
                return 1; // b va antes que a
            }


            const deliveryA = a.delivery ? String(a.delivery) : '';
            const deliveryB = b.delivery ? String(b.delivery) : '';

            return deliveryA.localeCompare(deliveryB);

        });

        const renderItems = [];
        let lastCodigoProveedor = null;

        articulos.forEach((item) => {
            // Comprobar si el proveedor actual es diferente al anterior
            const isSameProveedor = lastCodigoProveedor === item.codigo_proveedor;

            // Si es un nuevo proveedor (o el primero), insertamos la fila de encabezado
            if (!isSameProveedor) {
                renderItems.push({
                    id: `header-${item.codigo_proveedor}`, 
                    codigo_proveedor: item.codigo_proveedor,
                    descripcion_articulo: item.descripcion_articulo, 
                    cantidad_solicitada: item.cantidad_solicitada, 
                    isHeader: true,
                    rowClass: 'header-row',
                });
                // Actualizamos el último proveedor visto
                lastCodigoProveedor = item.codigo_proveedor;
            }

            renderItems.push({
                ...item, 
                rowClass: isSameProveedor ? 'same-provider' : 'new-provider', // Clase si 
                isHeader: false, // Esta NO es una fila de header
            });


        });

        return renderItems;
    };
    
    render() {

        const columnasArticulos = [
            {
                title: "Código",
                dataIndex: "codigo_proveedor",
                key: "codigo_proveedor",
            },
            {
                title: "Descripción",
                dataIndex: "descripcion_articulo",
                key: "descripcion_articulo",
            },
            {
                title: "Cant. Solicitada", // Columna a modificar
                dataIndex: "cantidad_solicitada",
                key: "cantidad_solicitada",
                render: (text, record) => {
                    // Solo muestra la cantidad si NO es una fila de header
                    return record.isHeader ? text : null;
                }
            },
            {
                title: "Cant. Recibida",
                dataIndex: "cantidad_recibida_prev",
                key: "cantidad_recibida_prev",
            },
            ["Drive"].includes(localStorage.getItem("role")) && {
                title: "Cant. Embarcada",
                dataIndex: "cantidad_embarcada",
                key: "cantidad_embarcada",
            },
            {
                title: "Codigo Embarque",
                dataIndex: "deliveryReception",
                key: "deliveryReception",
            },
            {
                title: "UDMP",
                dataIndex: "unidad_medida",
                key: "unidad_medida",
            },
            {
                title: "Estatus",
                dataIndex: "status",
                key: "status",
                render: (estatus, record) => { 
                    if (record.isHeader) {
                        return null; // O return '';
                    }
                    return (
                        <Tag
                            color={estatus === "Abierto" ? "#6fa8dcff" : estatus === "Terminado" ? "#092f50" : estatus === "Pendiente" ? "#d8b000" : estatus === "Planeado" ? "#3d85c6ff" : estatus === "Embarcado" ? "#0b5394ff" : ''}
                            key={estatus}>
                            {estatus}
                        </Tag>
                    );
                }
            }, 
            ["Drive"].includes(localStorage.getItem("role")) && {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (value, record) => (
                    <div>
                        <div>
                            <span className={
                                (( record.status === "Creado" ) && ["Drive", "Barista"].includes(localStorage.getItem("role"))) || 
                                (( record.status === "Creado" ) && localStorage.getItem("role") === 'Administrador') ? "" : "display-none"} 
                                style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={ "Eliminar artículo" }>
                                    <Button
                                        icon="close"
                                        className="btnCancelarPedido"
                                        onClick={() => {
                                            this.setState({ objCancelarArticulo: record, mostrarConfirmacioneliminar: true })
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                        </div>
                    </div>
                )
            }
        ].filter(Boolean);

        return (
            <div>
                <style>
                            {`
                    .header-row {
                        font-weight: bold;
                        background-color:rgba(183, 183, 183, 0.45);  /* Fondo claro para las filas de tipo header */
                    }
                    .detail-row {
                        background-color:rgb(254, 254, 254);  /* Fondo para las filas de desglose */
                    }
                            `}
                </style>
                
                <Modal
                    title={ this.props.pedido_selected !== null ? "Detalle de pedido " + ((this.props.pedido_selected.pedido_sap !== null) ? "número #" + this.props.pedido_selected.pedido_sap : "") : ""}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    width={"85%"}
                    maskClosable={false}
                    centered={true}
                    footer={
                        [
                            <Button
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>

                        <Table
                            size="small"
                            pagination={false}
                            locale={{ emptyText: 'No se han encontrado resultados.' }}
                            rowKey="id"
                            rowClassName={(record) => record.isHeader ? 'header-row' : 'detail-row'} // Aplicar la clase dependiendo si es header o detalle
                            columns={columnasArticulos}
                            dataSource={this.state.articulosPedido} // Usamos articulos procesados

                        />

                    </Spin>
                </Modal>
                <Modal
                    title={<p style={{ textAlign: "center", marginBottom: 0 }}>Confirmación para eliminar artículo</p>}
                    onCancel={() => {
                        let state = { ...this.state };
                        state.mostrarConfirmacioneliminar = false;
                        this.setState(state);
                    }}
                    centered={true}
                    visible={this.state.mostrarConfirmacioneliminar}
                    maskClosable={false}
                    footer={[
                        <Button
                            className="btnCancelar"
                            key="back"
                            onClick={() => {
                                let state = { ...this.state };
                                state.mostrarConfirmacioneliminar = false;
                                this.setState(state);
                            }}>
                            Regresar
                        </Button>,
                        <Button
                            className="btnVerCrearGuardar"
                            key="submit"
                            type="primary"
                            disabled={this.state.bloquearBtn}
                            onClick={() => {
                                this.eliminarArticulo();
                            }}
                        >
                            Continuar
                        </Button>
                    ]}
                >
                    <p style={{ textAlign: "center" }}>Se va a eliminar el producto {this.state.objCancelarArticulo !== null ? this.state.objCancelarArticulo.descripcion : ""} del pedido. ¿Desea continuar?</p>
                </Modal>
            </div>
        )
    }
}